import React, { Component } from "react";


export default class ErrorPage extends Component {
  render() {
    return (
      <div>
        <h3>This page does not exist</h3>
      </div>
    );
  }
}